import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { USER_CONTACTS_STATE } from '../../tokens';
import { DisplayNameComponent } from '../display-name/display-name.component';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { ContactsApiService } from '../../../api';
import { Subject } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { createActionState } from '@at/shared';

@Component({
  selector: 'at-notifications',
  standalone: true,
  imports: [DisplayNameComponent, CdkMenuTrigger, CdkMenu, CdkMenuItem],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class NotificationsComponent {
  private readonly contactsApi = inject(ContactsApiService);
  private readonly handleContactSubject = new Subject<{ action: 'accept' | 'reject'; userId: string }>();
  readonly contacts = inject(USER_CONTACTS_STATE);

  private readonly notificationButtonLabel: string = 'Show notifications menu';

  protected readonly notificationsCount = computed<number | undefined>(
    () => this.contacts().data?.receivedRequests?.length,
  );

  readonly handleContactState = toSignal(
    createActionState({
      trigger: this.handleContactSubject,
      apiCall: (req) => this.contactsApi.handleContactRequest(req),
      onSucceed: () => this.contacts().update(),
    }),
  );

  protected acceptContactRequest(contactId: string): void {
    this.handleContactSubject.next({ action: 'accept', userId: contactId });
  }

  protected rejectContactRequest(contactId: string): void {
    this.handleContactSubject.next({ action: 'reject', userId: contactId });
  }

  protected getNotificationsButtonAriaLabel(): string {
    const notificationsCount: number | undefined = this.notificationsCount();
    const notificationsText: string = notificationsCount && notificationsCount > 1 ? 'notifications' : 'notification';
    return notificationsCount
      ? `${this.notificationButtonLabel}. You currently have ${notificationsCount} ${notificationsText}`
      : this.notificationButtonLabel;
  }
}
